import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const getRoleBasedRoutes = async () => {
  try {
    const response = await axiosSetup.get("/navigation");
    return response?.data;
  } catch (error) {
    console.error(
      "Failed to fetch role based navigation please contact admin:",
      error,
    );
    toast.error("Failed to fetch role based navigation please contact admin");
    throw error;
  }
};
